import React, { CSSProperties } from "react";
import cx from "classnames";
import styles from "./popover-item.module.scss";

export interface IPopoverItem {
  children?: React.ReactNode;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const PopoverItem = (props: IPopoverItem) => {
  return (
    <div className={cx(styles.popover_item, props.className)} style={props.style} id={props.htmlId}>
      {props.children}
    </div>
  );
};

PopoverItem.defaultProps = {};
